module.exports = __webpack_public_path__ + "static/media/jh.ac29e13c.png";